import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../store/auth';

interface RoleRouteProps {
  /** 允许访问的角色列表 */
  roles: string[];
  children: ReactNode;
}

/**
 * 角色守卫：用户角色不在允许列表则跳转 /403
 *
 * 需置于 ProtectedRoute 之内（已保证登录态）。
 */
export default function RoleRoute({ roles, children }: RoleRouteProps) {
  const user = useAuthStore((s) => s.user);

  if (!user) {
    return <Navigate to="/login" replace />;
  }
  if (!roles.includes(user.role)) {
    return <Navigate to="/403" replace />;
  }
  return <>{children}</>;
}
